import React from 'react';
import { cn } from '../../utils/cn';

const BASE =
    'inline-flex items-center justify-center border px-2 py-0.5 text-xs w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none transition-colors overflow-hidden';

const VARIANTS = {
    default: 'border-transparent bg-primary-600 text-fg-on-solid',
    secondary: 'border-transparent bg-surface-muted text-fg',
    destructive: 'border-transparent bg-danger-solid text-fg-on-solid',
    outline: 'text-fg border-line hover:bg-surface-muted',
    // Soft status tones (StatusBadge).
    success: 'text-success bg-success-soft border-success-line',
    warning: 'text-warning bg-warning-soft border-warning-line',
    danger: 'text-danger bg-danger-soft border-danger-line',
    neutral: 'text-fg-muted bg-surface-muted border-line',
};

const SHAPES = {
    rounded: 'rounded-chip font-medium',
    pill: 'rounded-full font-semibold',
};

/**
 * Small inline label.
 * @param {'default'|'secondary'|'destructive'|'outline'|'success'|'warning'|'danger'|'neutral'} [variant]
 * @param {'rounded'|'pill'} [shape]
 */
export function Badge({ className, variant = 'default', shape = 'rounded', ...props }) {
    return (
        <span
            className={cn(BASE, VARIANTS[variant] || VARIANTS.default, SHAPES[shape] || SHAPES.rounded, className)}
            {...props}
        />
    );
}
